import React, { useContext } from "react"
import { Puff } from "react-loader-spinner"

import styles from "./index.module.scss"
import { ColorsContext } from "../../../contexts/Colors"

export default function RcmpLoading(props) {
  const { bShow, className, size, color = "#6CB6E3", bCentered = false, ...oRest } = props

  const colorContext = useContext(ColorsContext)

  if (!bShow) return null

  const nSize = size ? size : 80

  const containerClasses = `${styles.loadingContainer} ${bCentered ? styles.centered : ""} ${className ? className : ""}`
  const cColor = colorContext?.oCurrentDepartamentColors?.opc_cprimary_color || color
  
  return (
    <div className={containerClasses}>
      <Puff
        height={nSize}
        width={nSize}
        color={cColor}
        visible={true}
        ariaLabel="puff-loading"
        strokeWidth={5}
        strokeWidthSecondary={3}
        {...oRest}
      />
    </div>
  )
}
